import React from 'react'
import { Link } from 'react-router-dom'
import { Music, Github, Twitter, Mail } from 'lucide-react'

const Footer: React.FC = () => {
  return (
    <footer className="bg-black/95 backdrop-blur-md border-t border-white/10 mt-auto">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
          {/* Brand */}
          <div className="col-span-1 md:col-span-2">
            <div className="flex items-center space-x-2 mb-4">
              <Music className="h-8 w-8 text-orange-500 group-hover:text-orange-400 transition-colors"/>
              <span className="text-2xl font-bold gradient-text">SoundWrapped</span>
            </div>
            <p className="text-slate-400 mb-4 max-w-md">
              Discover your music taste with personalized insights from SoundCloud. 
              Your musical journey, beautifully visualized.
            </p>
            <p className="text-slate-500 text-xs mb-6 max-w-md">
              Music data, artist images, track artwork, and audio streams are provided by SoundCloud. SoundCloud is a trademark of SoundCloud Global Limited & Co. KG.
            </p>
            <div className="flex space-x-4">
              <a
                href="https://github.com/Tazwar89/SoundWrapped"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-white/5 hover:bg-white/10 transition-colors"
              >
                <Github className="h-5 w-5 text-slate-400" />
              </a>
              <a
                href="https://twitter.com/Tazwar89"
                target="_blank"
                rel="noopener noreferrer"
                className="p-2 rounded-lg bg-white/5 hover:bg-white/10 transition-colors"
              >
                <Twitter className="h-5 w-5 text-slate-400" />
              </a>
              <a
                href="mailto:tazwar.sikder@outlook.com"
                className="p-2 rounded-lg bg-white/5 hover:bg-white/10 transition-colors"
              >
                <Mail className="h-5 w-5 text-slate-400" />
              </a>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold text-slate-200 mb-4">Quick Links</h3>
            <ul className="space-y-2">
              <li>
                <Link to="/dashboard" className="text-slate-400 hover:text-white transition-colors">
                  Dashboard
                </Link>
              </li>
              <li>
                <Link to="/wrapped" className="text-slate-400 hover:text-white transition-colors">
                  Your Wrapped
                </Link>
              </li>
              <li>
                <Link to="/music-taste-map" className="text-slate-400 hover:text-white transition-colors">
                  Music Taste Map
                </Link>
              </li>
              <li>
                <Link to="/profile" className="text-slate-400 hover:text-white transition-colors">
                  Profile
                </Link>
              </li>
            </ul>
          </div>

          {/* Support */}
          <div>
            <h3 className="text-lg font-semibold text-slate-200 mb-4">Support</h3>
            <ul className="space-y-2">
              <li>
                <a href="#" className="text-slate-400 hover:text-white transition-colors">
                  Help Center
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-400 hover:text-white transition-colors">
                  Privacy Policy
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-400 hover:text-white transition-colors">
                  Terms of Service
                </a>
              </li>
              <li>
                <a href="#" className="text-slate-400 hover:text-white transition-colors">
                  Contact Us
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="border-t border-white/10 mt-8 pt-8">
          <div className="flex flex-col md:flex-row justify-between items-center">
            <p className="text-slate-400 text-sm">
              © 2026 SoundWrapped. All rights reserved.
            </p>
            <p className="text-slate-500 text-sm mt-2 md:mt-0">
              Made by a SoundCloud fan, for SoundCloud fans.
            </p>
          </div>
        </div>
      </div>
    </footer>
  )
}

export default Footer